import { transition } from '@helpers/animate';
import styled from 'styled-components';
const Background = styled.div `
  ${transition('transform', 1)};

  position: fixed;
  top: 0;
  right: 0;
  display: block;
  background: var(--tintColor);
  height: 100%;
  width: 100%;
  backdrop-filter: blur(3px);
  cursor: zoom-out;
  transform: translateX(100%);
  z-index: 9999;

  [data-open='true'] & {
    transform: translateX(0);
  }
`;
const BackgroundStyles = {
    Background,
};
export default BackgroundStyles;
